import { closeDropdownFromElementWithin } from '#/components/Dropdown/closeDropdownFromElementWithin';

import { clickActionsAttr } from './click-actions.attributes';
import { richDetailsCloseFromWithinAttr } from './rich-details.attributes';
import type { Snippet } from './types/Snippet';
import { openModalElement } from './utils/open-modal-element';
import { trackClickedElement } from './utils/track-clicked-element';

export const clickActionsSnippet = {
  click(el, event) {
    const target = el.closest(`[${clickActionsAttr}]`);
    if (!target) return;

    if (target.hasAttribute(richDetailsCloseFromWithinAttr)) {
      closeDropdownFromElementWithin(target);
    }

    trackClickedElement(target);
    openModalElement(target, event);
  },
} satisfies Snippet;
